import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MachineDashboardActions } from '../state/MachineDashboard/machineDashboardSlice';
import { MachineDashboardSelectors } from '../state/MachineDashboard/machineDashboardSelectors';
import { MachineDashboardWidgetId } from '../types/machineDashboardWidgetListState.types';
import { MachinesReport } from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';

export interface MachineDashboardWidgetListHookResult {
  machines: MachinesReport[];
  thumbnailUrlsByMachineId: Record<string, string>;
  isLoading: boolean;
  isLoadingMore: boolean;
  hasMore: boolean;
  loadMore: () => void;
}

export const useMachineDashboardWidgetList = (
  widgetId: MachineDashboardWidgetId
): MachineDashboardWidgetListHookResult => {
  const dispatch = useDispatch();

  const machines = useSelector(MachineDashboardSelectors.selectWidgetListMachines(widgetId));
  const thumbnailUrlsByMachineId = useSelector(
    MachineDashboardSelectors.selectWidgetListThumbnailUrlsByMachineId(widgetId)
  );
  const isLoading = useSelector(MachineDashboardSelectors.selectWidgetListIsLoading(widgetId));
  const isLoadingMore = useSelector(MachineDashboardSelectors.selectWidgetListIsLoadingMore(widgetId));
  const hasMore = useSelector(MachineDashboardSelectors.selectWidgetListHasMore(widgetId));

  const loadMore = useCallback((): void => {
    if (!hasMore || isLoadingMore) {
      return;
    }

    dispatch(MachineDashboardActions.machineDashboardWidgetListLoadMoreRequest({ widgetId }));
  }, [dispatch, widgetId, hasMore, isLoadingMore]);

  return {
    machines,
    thumbnailUrlsByMachineId,
    isLoading,
    isLoadingMore,
    hasMore,
    loadMore,
  };
};
